import dashboardNavbarConst from '@/consts/dashboardNavbar.const.js';
import mandateModeConst from '@/consts/mandateMode.const';
import mandateTabBarConst from '@/consts/mandateTabBar.const';
import userRoleConst from '@/consts/userRole.const';

import mandateGuard from '@/guards/mandate/mandate.guard.js';
import mandateListGuard from '@/guards/mandate/mandateList.guard.js';
import mandatePropertyListGuard from '@/guards/mandate/mandatePropertyList.guard';
import mandatePropertyGuard from '@/guards/mandate/mandateProperty.guard.js';
// import propertyListGuard from '@/guards/mandate/propertyList.guard.js';

const mandatesRoutes = [
  // Mandate List
  {
    path: '/mandates',
    name: 'mandates',
    component: () => import(/* webpackChunkName: "mandates" */ '@/pages/globalEndToEnd/mandates/mandatesList/mandatesList.vue'),
    beforeEnter: mandateListGuard,
    meta: {
      id: dashboardNavbarConst.MANDATES,
      auth: true,
      role: 'ADMIN',
    },
  },
  // Add Mandate
  {
    path: '/mandates/new',
    name: 'mandateNew',
    component: () => import(/* webpackChunkName: "mandateAdd" */ '@/pages/globalEndToEnd/mandates/mandatesAddMandate/mandatesAddMandate.vue'),
    meta: {
      id: dashboardNavbarConst.MANDATES,
      auth: true,
      role: 'ADMIN',
    },
  },
  // Mandate Details
  {
    path: '/mandates/:mandateId',
    name: 'mandateDetails',
    component: () => import(/* webpackChunkName: "mandateDetails" */ '@/pages/globalEndToEnd/mandates/mandatesDetails/mandatesDetails.vue'),
    meta: {
      auth: true,
      // ? ¿No debería ser un array de roles?
      role: userRoleConst.ADMIN,
    },
    children: [
      // Mandate Details - Update
      {
        path: '/mandates/:mandateId/edit',
        name: 'mandateDetailsEdit',
        component: () => import(/* webpackChunkName: "mandateDetailsEdit" */ '@/pages/globalEndToEnd/mandates/mandatesDetails/mandatesDetailsTabView.vue'),
        beforeEnter: mandateGuard,
        meta: {
          id: dashboardNavbarConst.MANDATES,
          tabId: mandateTabBarConst.DETAILS,
          mode: mandateModeConst.EDIT,
          auth: true,
          role: userRoleConst.ADMIN,
        },
      },
      // Mandate Details - Read
      {
        path: '/mandates/:mandateId/view',
        name: 'mandateDetailsView',
        component: () => import(/* webpackChunkName: "mandateDetailsView" */ '@/pages/globalEndToEnd/mandates/mandatesDetails/mandatesDetailsTabView.vue'),
        beforeEnter: mandateGuard,
        meta: {
          id: dashboardNavbarConst.MANDATES,
          tabId: mandateTabBarConst.DETAILS,
          mode: mandateModeConst.READ,
          auth: true,
          role: userRoleConst.ADMIN,
        },
      },
      // Mandate Property List
      {
        path: '/mandates/:mandateId/properties',
        name: 'mandateProperties',
        component: () => import(/* webpackChunkName: "mandateProperties" */ '@/pages/globalEndToEnd/mandates/mandatesDetails/mandatesDetailsTabProperties.vue'),
        beforeEnter: mandatePropertyListGuard,
        meta: {
          id: dashboardNavbarConst.MANDATES,
          tabId: mandateTabBarConst.PROPERTIES,
          auth: true,
          role: userRoleConst.ADMIN,
        },
      },
    ],
  },
  // Mandate Property ADD
  {
    path: '/mandates/:mandateId/properties/add',
    name: 'mandateAddProperty',
    component: () => import(/* webpackChunkName: "mandateAddProperty" */ '@/pages/globalEndToEnd/mandates/mandatesAddProperty/mandatesAddProperty.vue'),
    meta: {
      id: dashboardNavbarConst.MANDATES,
      auth: true,
      role: userRoleConst.ADMIN,
    },
  },
  // Mandate Property
  {
    path: '/mandates/:mandateId/properties/:propertyId',
    // props: true, CHECK THIS FOR LATER
    name: 'mandatePropertyDetails',
    component: () => import(/* webpackChunkName: "mandateView" */ '@/pages/globalEndToEnd/mandates/mandateProperty/mandateProperty.vue'),
    beforeEnter: mandatePropertyGuard,
    meta: {
      auth: true,
      role: userRoleConst.ADMIN,
    },
    children: [
      {
        path: '/mandates/:mandateId/properties/:propertyId/general',
        name: 'mandatePropertyGeneral',
        component: () => import(/* webpackChunkName: "pixResearchComparable" */ '@/pages/globalEndToEnd/mandates/mandateProperty/propertyDetail.vue'),
        meta: {
          id: dashboardNavbarConst.MANDATES,
          tabId: mandateTabBarConst.PROPERTIES_MANDATES,
          mode: mandateModeConst.READ,
          auth: true,
          role: userRoleConst.ADMIN,
        },
      },
    ],
  },
];

export default mandatesRoutes;
